<template>
  <bimButton
    :label="label"
    :color="color"
    @click="$emit('click')"
    class="button button-leave-request add-spec"
  />
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
export default {
  name: "ButtonLeaveRequest",
  components: {
    bimButton,
  },
  props: {
    label: {
      type: String,
      default: "Оставить заявку"
    },
    color: {
      type: String,
      validator: val => ["primary", "luxury"].includes(val),
      default: "primary",
    }
  }
}
</script>

<style lang="scss">
.button.button-leave-request.add-spec {
  height: auto;
  padding: 21px 48px;
  font-size: 18px;
  line-height: 1.44;
  font-weight: bold;
}
</style>
